import React,{ useState,useContext} from 'react';
import BranchContext from "./../context/branch";

import Registernew from './registerhub'
import RegisterCurrent from './register'

const Register = (props) => {
    const [Id, setId] = useState(props.match.params.id);

 
    const { currentBranch } = useContext(BranchContext);
    return ( <>
    {currentBranch && currentBranch._id && (currentBranch._id > 519 || parseInt(currentBranch._id)===510 || parseInt(currentBranch._id)===501 ) ?
     <Registernew Id ={Id}
    
    />
    
    : currentBranch && currentBranch._id && currentBranch._id ? <RegisterCurrent Id ={Id}/> :  null
    
    }
    
    </> );
}
 
export default Register;